
import React, { useState, useEffect, useContext } from 'react';
import { Box, Grid, Paper, Button, Typography, TextField, Checkbox, Table, TableHead, Chip, TableRow, TableCell, TableBody, Autocomplete, Radio, FormControlLabel, fabClasses } from '@mui/material';
import ApiService from "../../functions/apiService";
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { toast } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
// import CalendarPicker from '../../components/Calendar/CalendarPicker';
import NewCalendarPicker from '../../components/Calendar/NewCalendarPicker'
import CustomAccordion from './CustomAccordion';
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { CircularProgress } from "@material-ui/core";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useNavigate } from 'react-router-dom';

const VolunteerSignupNew = ({ embedded = false }) => {
    const { permission, v3Data, pages, user } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('my-signups');
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [totalWeeks, setTotalWeeks] = useState([]);
    const [selected, setSelected] = useState({});
    const [selectedShifts, setSelectedShifts] = useState([])
    const [selectedEmp, setSelectedEmp] = useState('')
    const [shiftType, setShiftType] = useState([]);
    const [anyExpanded, setAnyExpanded] = useState(true);
    const [overtimeHours, setOvertimeHours] = useState([])
    const [dropdownValues, setDropdownValues] = useState({});
    const [pendingUpdates, setPendingUpdates] = useState({});
    const navigation = useNavigate();
    const [employees, setEmployees] = useState([])

    const shiftData = () => {
        ApiService.get('/shiftTypes').then(({ data }) => {
            setShiftType(data?.data || [])
        }).catch(() => {
            toast.error("Error")
        })
    }
    const handleDropdownChange = (date, shiftCode, value) => {
        const key = `${date}_${shiftCode}`;
        setDropdownValues(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const loadEmployees = () => {
        ApiService.get('/employees-list?search=')
            .then(({ data }) => {
                var tempArr = []
                data.data.map((emp) => {
                    var obj = emp
                    obj.label = `${emp.employee_assignment.EA_Rank} ${emp.fullName}`
                    tempArr.push(obj)
                })
                setEmployees(tempArr)
            })
            .catch((e) => {
                setLoading(false);
            })
    }

    useEffect(()=>{
        loadEmployees()
    }, [])
    
    // const addRowForUpdate = (shiftObj) => {
    //     setPendingUpdates(prev => [...prev, shiftObj]);
    // };
    // const applyPendingUpdates = () => {
    //     setTotalWeeks(prev => {
    //         let temp = [...prev];

    //         pendingUpdates.forEach(update => {
    //             for (let w = 0; w < temp.length; w++) {
    //                 for (let d = 0; d < temp[w].days.length; d++) {

    //                     if (temp[w].days[d].shiftDate === update.ShiftDate) {

    //                         const sIndex = temp[w].days[d].shifts.findIndex(
    //                             s => s.ShiftCode == update.ShiftCode
    //                         );

    //                         if (sIndex !== -1) {
    //                             temp[w].days[d].shifts[sIndex] = {
    //                                 ...temp[w].days[d].shifts[sIndex],
    //                                 start_time: update.Start_Time,
    //                                 end_time: update.End_Time,
    //                                 isFullTime: update.isFullTime,
    //                                 prevAction: update.prevAction,
    //                                 hasPrevAction: update.hasPrevAction

    //                             };
    //                         }
    //                     }
    //                 }
    //             }
    //         });

    //         return [...temp];
    //     });

    //     setPendingUpdates([]);
    // };
// console.log("totalWeeks===>90",totalWeeks)
    const getDropdownValue = (date, shiftCode) => {
        const key = `${date}_${shiftCode}`;
        return dropdownValues[key] || "";
    };
    useEffect(() => {
        shiftData()
    }, [])

    const selectShift = (date, code, type, time, shift_starttime, shift_endtime) => {
        var tempArr = [...selectedShifts];
        let extObj = tempArr.find((a) => a.ShiftDate == date && a.ShiftCode == code);

        if (extObj) {
            if (type == 'fulltime') {

                // 🔥 FIX: If custom time exists → do NOT convert to full time
                const hasCustom =
                    (extObj.Start_Time && extObj.Start_Time !== shift_starttime) ||
                    (extObj.End_Time && extObj.End_Time !== shift_endtime);

                if (hasCustom) {
                    // keep custom time, make sure fulltime is false
                    Object.assign(extObj, {
                        isFullTime: false
                    });
                } else {
                    // normal fulltime logic
                    if (extObj.isFullTime) {
                        const index = tempArr.findIndex(
                            (a) => a.ShiftDate == date && a.ShiftCode == code
                        );
                        tempArr.splice(index, 1);
                    } else {
                        Object.assign(extObj, {
                            isFullTime: true,
                            Start_Time: shift_starttime,
                            End_Time: shift_endtime
                        });
                    }
                }
            }

            else if (type == 'start_time') {
                Object.assign(extObj, {
                    Start_Time: dayjs(time).format("HH:mm:ss"),
                    isFullTime: false
                });
            } else if (type == 'end_time') {
                Object.assign(extObj, {
                    End_Time: dayjs(time).format("HH:mm:ss"),
                    isFullTime: false
                });
            } else if (type == 'unavailable') {
                const index = tempArr.findIndex(
                    (a) => a.ShiftDate == date && a.ShiftCode == code
                );
                tempArr.splice(index, 1);
            }
        } else {
            var tempObj = {
                ShiftDate: date,
                ShiftCode: code,
            };

            var timeData = shiftType.find((ele) => ele.ShiftCode == tempObj.ShiftCode)

            if (type == "fulltime") {
                Object.assign(tempObj, {
                    Start_Time: shift_starttime || timeData?.Start_Time,
                    End_Time: shift_endtime || timeData?.End_Time,
                    isFullTime: true
                });
                tempArr.push(tempObj);
            } else if (type == "start_time") {
                Object.assign(tempObj, {
                    Start_Time: dayjs(time).format("HH:mm:ss"),
                    isFullTime: false
                });
                tempArr.push(tempObj);
            } else if (type == "end_time") {
                Object.assign(tempObj, {
                    End_Time: dayjs(time).format("HH:mm:ss"),
                    isFullTime: false
                });
                tempArr.push(tempObj);
            }
        }
        setSelectedShifts(tempArr);
        return tempArr;
    };
    const isShiftSelected = (date, code) => {
        return selectedShifts.some((a) => a.ShiftDate == date && a.ShiftCode == code);
    };

    const getSelectedShiftTimes = (date, code) => {
        const selected = selectedShifts.find(
            (a) => a.ShiftDate == date && a.ShiftCode == code
        );
        return selected || null;
    };



    const isShiftFullTime = (date, code) => {
        const shift = selectedShifts.find((a) => a.ShiftDate == date && a.ShiftCode == code);
        return shift?.isFullTime || false;
    };
    // const loadShiftData = (loader) => {
    //     const month = moment(selectedDate).format("MM");
    //     const year = moment(selectedDate).format("YYYY");
    //     setLoading(loader)
    //     const body = {
    //         month,
    //         year
    //     }
    //     ApiService.post('/mySignups', body)
    //         .then((data) => {
    //             const weeks = data?.weeks?.map(week => ({
    //                 ...week,
    //                 days: week.days.map(day => ({
    //                     ...day,
    //                     shifts: day.shifts.map(shift => ({
    //                         ...shift,
    //                         original_start_time: shift.start_time,
    //                         original_end_time: shift.end_time,
    //                         hasPrevAction: shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== null
    //                     }))
    //                 }))
    //             }));

    //             setTotalWeeks(weeks || []);
    //             const initialSelectedShifts = [];
    //             weeks?.forEach(week => {
    //                 week.days?.forEach(day => {
    //                     day.shifts?.forEach(shift => {
    //                         if (shift.isFullTime === true) {
    //                             initialSelectedShifts.push({
    //                                 ShiftDate: day.shiftDate,
    //                                 ShiftCode: shift.ShiftCode,
    //                                 Start_Time: shift.start_time,
    //                                 End_Time: shift.end_time,
    //                                 isFullTime: true
    //                             });
    //                         }

    //                         if (shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== '' && shift.prevAction.includes('|')) {
    //                             const [startTime, endTime] = shift.prevAction.split('|');
    //                             initialSelectedShifts.push({
    //                                 ShiftDate: day.shiftDate,
    //                                 ShiftCode: shift.ShiftCode,
    //                                 Start_Time: startTime,
    //                                 End_Time: endTime,
    //                                 isFullTime: false
    //                             });
    //                         }
    //                     });
    //                 });
    //             });
    //             setSelectedShifts(initialSelectedShifts);
    //             setLoading(false);

    //         })
    //         .catch(() => {
    //             setLoading(false)
    //         })
    // }
    // const loadShiftData = (loader) => {
    //     const month = moment(selectedDate).format("MM");
    //     const year = moment(selectedDate).format("YYYY");
    //     setLoading(loader)
    //     const body = {
    //         month,
    //         year
    //     }
    //     ApiService.post('/mySignups', body)
    //         .then((data) => {
    //             const weeks = data?.weeks?.map(week => ({
    //                 ...week,
    //                 days: week.days.map(day => ({
    //                     ...day,
    //                     shifts: day.shifts.map(shift => ({
    //                         ...shift,
    //                         original_start_time: shift.start_time,
    //                         original_end_time: shift.end_time,
    //                         hasPrevAction: shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== null
    //                     }))
    //                 }))
    //             }));

    //             setTotalWeeks(weeks || []);

    //             const initialSelectedShifts = [];
    //             const initialDropdownValues = {};

    //             weeks?.forEach(week => {
    //                 week.days?.forEach(day => {
    //                     day.shifts?.forEach(shift => {
    //                         const key = `${day.shiftDate}_${shift.ShiftCode}`;

    //                         // If prevAction is FULLTIME
    //                         if (shift.prevAction === 'FULLTIME' || (shift.isFullTime === true && !shift.prevAction?.includes('|'))) {
    //                             initialSelectedShifts.push({
    //                                 ShiftDate: day.shiftDate,
    //                                 ShiftCode: shift.ShiftCode,
    //                                 Start_Time: shift.start_time,
    //                                 End_Time: shift.end_time,
    //                                 isFullTime: true
    //                             });
    //                             initialDropdownValues[key] = "full shift";
    //                         }
    //                         // If prevAction has custom time (e.g., "07:00:00|17:00:00")
    //                         else if (shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== '' && shift.prevAction.includes('|')) {
    //                             const [startTime, endTime] = shift.prevAction.split('|');
    //                             initialSelectedShifts.push({
    //                                 ShiftDate: day.shiftDate,
    //                                 ShiftCode: shift.ShiftCode,
    //                                 Start_Time: startTime,
    //                                 End_Time: endTime,
    //                                 isFullTime: false
    //                             });

    //                             // 👇 Convert "07:00:00|16:59:59" back to "7-17" format
    //                             const startHour = parseInt(startTime.split(':')[0], 10);
    //                             const endMinute = parseInt(endTime.split(':')[1], 10);
    //                             const endHour = parseInt(endTime.split(':')[0], 10);

    //                             // If end time is XX:59:59, then actual end hour is endHour + 1
    //                             const actualEndHour = endMinute === 59 ? endHour + 1 : endHour;

    //                             const dropdownValue = `${startHour}-${actualEndHour}`;
    //                             initialDropdownValues[key] = dropdownValue;

    //                             console.log(`Converting ${startTime}|${endTime} to dropdown: ${dropdownValue}`);
    //                         }
    //                     });
    //                 });
    //             });

    //             setSelectedShifts(initialSelectedShifts);
    //             setDropdownValues(initialDropdownValues);
    //             setLoading(false);

    //         })
    //         .catch(() => {
    //             setLoading(false)
    //         })
    // }
    //         const loadHoursData = () => {
    //             setLoading(true)
    //             ApiService.get('/getHourShiftVolunteer')
    //                 .then(({ data }) => {
    //                     setOvertimeHours(data?.data)
    //                     setLoading(false)
    //                 })
    //                 .catch(() => {
    //                     setLoading(false)
    //                 })
    //         }

    //     useEffect(() => {
    //         loadShiftData(true)
    //         loadHoursData()
    //     }, [selectedDate])
    useEffect(() => {
        const loadAllData = async () => {
            setLoading(true);
            try {
                // 🔥 Dono APIs parallel mein call karo
                const [hoursResponse, shiftsResponse] = await Promise.all([
                    ApiService.get('/getHourShiftVolunteer'),
                    ApiService.post('/mySignups', {
                        month: moment(selectedDate).format("MM"),
                        year: moment(selectedDate).format("YYYY"),
                        Emp_Code : selectedEmp
                    })
                ]);

                const hoursData = hoursResponse?.data?.data || {};
                setOvertimeHours(hoursData);
                const weeks = shiftsResponse?.weeks?.map(week => ({
                    ...week,
                    days: week.days.map(day => ({
                        ...day,
                        shifts: day.shifts.map(shift => ({
                            ...shift,
                            original_start_time: shift.start_time,
                            original_end_time: shift.end_time,
                            hasPrevAction: shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== null
                        }))
                    }))
                }));

                setTotalWeeks(weeks || []);

                const initialSelectedShifts = [];
                const initialDropdownValues = {};

                weeks?.forEach(week => {
                    week.days?.forEach(day => {
                        day.shifts?.forEach(shift => {
                            const key = `${day.shiftDate}_${shift.ShiftCode}`;

                            if (shift.prevAction === 'FULLTIME' || (shift.isFullTime === true && !shift.prevAction?.includes('|'))) {
                                initialSelectedShifts.push({
                                    ShiftDate: day.shiftDate,
                                    ShiftCode: shift.ShiftCode,
                                    Start_Time: shift.start_time,
                                    End_Time: shift.end_time,
                                    isFullTime: true
                                });
                                initialDropdownValues[key] = "full shift";
                            }
                            else if (shift.prevAction && shift.prevAction !== 'FULLTIME' && shift.prevAction !== '' && shift.prevAction.includes('|')) {
                                const [startTime, endTime] = shift.prevAction.split('|');
                                initialSelectedShifts.push({
                                    ShiftDate: day.shiftDate,
                                    ShiftCode: shift.ShiftCode,
                                    Start_Time: startTime,
                                    End_Time: endTime,
                                    isFullTime: false
                                });

                                const startHour = parseInt(startTime.split(':')[0], 10);
                                const endHourRaw = parseInt(endTime.split(':')[0], 10);
                                const endMinute = parseInt(endTime.split(':')[1], 10);
                                const actualEndHour = endMinute === 59 ? endHourRaw + 1 : endHourRaw;
                                const timePattern = `${startHour}-${actualEndHour}`;

                                // 🔥 Use hoursData (not overtimeHours state)
                                const shiftName = shift.name;
                                const matchingKey = Object.keys(hoursData).find((key) =>
                                    shiftName.toLowerCase().includes(key.toLowerCase())
                                );

                                if (matchingKey && hoursData[matchingKey]) {
                                    const matchingOption = hoursData[matchingKey].find(opt =>
                                        opt.startsWith(timePattern)
                                    );

                                    if (matchingOption) {
                                        initialDropdownValues[key] = matchingOption;
                                    }
                                }
                            }
                        });
                    });
                });

                setSelectedShifts(initialSelectedShifts);
                setDropdownValues(initialDropdownValues);
                setLoading(false);

            } catch (err) {
                console.error(err);
                setLoading(false);
            }
        };

        loadAllData();
        shiftData();
    }, [selectedDate , selectedEmp]);


    const toggleAllCollapses = () => {
        setAnyExpanded(prev => !prev);
    };

    const saveSingleShift = async (shiftObj) => {

        try {
            const body = {
                ShiftDate: shiftObj.ShiftDate,
                ShiftCode: shiftObj.ShiftCode,
                Start_Time: shiftObj.Start_Time,
                End_Time: shiftObj.End_Time,
                isFullTime: shiftObj.isFullTime,
                Emp_Code : selectedEmp
            };

            const res = await ApiService.post("/saveMySignup", body);
            toast.success(res?.message);
            const key = `${shiftObj.ShiftDate}_${shiftObj.ShiftCode}`;
            setPendingUpdates(prev => ({
                ...prev,
                [key]: res  // Each shift has its own key
            }));

            // Also update selectedShifts
            setSelectedShifts(prev => {
                const exists = prev.find(
                    s => s.ShiftDate === shiftObj.ShiftDate && s.ShiftCode === shiftObj.ShiftCode
                );

                if (exists) {
                    return prev.map(s =>
                        s.ShiftDate === shiftObj.ShiftDate && s.ShiftCode === shiftObj.ShiftCode
                            ? { ...s, ...shiftObj }
                            : s
                    );
                } else {
                    return [...prev, shiftObj];
                }
            });

        } catch (err) {
            toast.error(err?.data?.message);
        }
    };
    const deleteSingleShift = async (shiftObj) => {
        try {
            const body = {
                ShiftDate: shiftObj.ShiftDate,
                ShiftCode: shiftObj.ShiftCode,
                Emp_Code:  selectedEmp ? selectedEmp : String(user?.Emp_Code || "")
            };
            const res = await ApiService.post("/deleteMySignup", body);
            toast.success(res?.message);
            const key = `${shiftObj.ShiftDate}_${shiftObj.ShiftCode}`;
            setPendingUpdates(prev => {
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });

            setSelectedShifts(prev =>
                prev.filter(
                    s => !(s.ShiftDate === shiftObj.ShiftDate && s.ShiftCode === shiftObj.ShiftCode)
                )
            );
            clearPendingUpdateForShift(shiftObj.ShiftDate, shiftObj.ShiftCode);
        } catch (err) {
            toast.error(err?.data?.message);
        }
    };


    const formatDate = (date) => {
        if (!date) return "";
        return moment(date, "YYYY-MM-DD").format("MMM DD");
    };
    const parseTimeRange = (str) => {
        const match = str.match(/^(\d+)-(\d+)/);
        if (!match) return null;

        const [_, start, end] = match;

        const startHour = parseInt(start, 10);
        const endHour = parseInt(end, 10) - 1;

        const startTime = dayjs().hour(startHour).minute(0).second(0);
        const endTime = dayjs().hour(endHour).minute(59).second(59);

        return {
            start: startTime.format('HH:mm:ss'),
            end: endTime.format('HH:mm:ss'),
        };
    };
    // const shouldShowCustomChip = (pendingUpdates, shiftDate, shiftCode) => {
    //     const key = `${shiftDate}_${shiftCode}`;
    //     const update = pendingUpdates[key];

    //     if (!update?.data) return false;

    //     const signup = update.data;

    //     return (
    //         signup.Value &&
    //         signup.Value !== 'FULLTIME'
    //     );
    // };
    const shouldShowCustomChip = (pendingUpdates, shiftDate, shiftCode) => {
        const key = `${shiftDate}_${shiftCode}`;
        const update = pendingUpdates[key];
        if (update?.data?.Value && update.data.Value !== 'FULLTIME') {
            return true;
        }

        const shiftFromUI = selectedShifts.find(
            s => s.ShiftDate === shiftDate && s.ShiftCode === shiftCode
        );

        if (
            v3Data?.V3_Overtime_Signup_Custom_Time_Allow === true ||
            v3Data?.V3_Overtime_Signup_Custom_Time_Allow === 'true'
        ) {
            return !!shiftFromUI && shiftFromUI.isFullTime === false;
        }


        return false;
    };




    const clearPendingUpdateForShift = (shiftDate, shiftCode) => {
        const key = `${shiftDate}_${shiftCode}`;
        setPendingUpdates(prev => {
            const updated = { ...prev };
            delete updated[key];
            return updated;
        });
    };


    const shouldShowDropdown = (shiftDate, shiftCode) => {
        return selectedShifts.some(
            s => s.ShiftDate === shiftDate && s.ShiftCode === shiftCode
        );
    };



    return (
        <>
            <Paper elevation={embedded ? 0 : 1} sx={{
                position: embedded ? 'static' : 'sticky',
                top: 0,
                zIndex: embedded ? 'auto' : 1100,
                backgroundColor: "#fff",
            }}
                className={embedded ? '' : 'p-4'} style={embedded ? { fontFamily: 'karla' } : { marginTop: "1rem", fontFamily: 'karla', position: 'sticky' }}>
                <div className='mb-4'>
                    <Grid container spacing={2} alignItems="center">
                        {!embedded && (
                            <Grid item xs={12} sm={6} md={permission.includes('Emp_Auth') ? 7.5 : 10}>
                                <Typography variant="h5">
                                    {v3Data?.V3_VERBIAGE_VOLUNTEER ?
                                        'Per-diem Signup' : 'Volunteer Signup'}
                                </Typography>
                            </Grid>
                        )}


                        {permission && permission.includes('Emp_Auth') &&
                            <Grid item xs={12} sm={6} md={embedded ? 4 : 2.5}>
                                <Autocomplete
                                    options={employees}
                                    getOptionLabel={(option) => option.label}
                                    onChange={(event, newValue) => setSelectedEmp(newValue?.Emp_Code || "")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            placeholder="Employee"
                                            variant="outlined"
                                            fullWidth
                                            size="small"
                                            sx={{
                                                "& .MuiInputBase-root": {
                                                    height: "48px",
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    alignItems: "center"
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                        }

                        <Grid item xs={12} sm={6} md={2} sx={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            <Grid item xs={12} sm="auto" md="auto">
                                <Button
                                    onClick={toggleAllCollapses}
                                    variant="outlined"
                                    startIcon={
                                        <Box
                                            component="img"
                                            src={anyExpanded ? '/images/collapse.svg' : '/images/expand.svg'}
                                            alt="Icon"
                                            sx={{ width: '16px', height: '16px' }}
                                        />
                                    }
                                    sx={{
                                        fontSize: { xs: '11px', sm: '12px' },
                                        padding: { xs: '4px 10px', sm: '5px 10px' },
                                        textTransform: 'none',
                                        fontFamily: 'karla',
                                        borderRadius: '8px',
                                        marginTop: '4px',
                                        borderColor: '#E0E0E0',
                                        color: '#000',
                                        '&:hover': {
                                            borderColor: '#BF1D2D',
                                            backgroundColor: 'rgba(191, 29, 45, 0.04)'
                                        }
                                    }}
                                >
                                    {anyExpanded ? "Click to Collapse" : "Click to Expand"}
                                </Button>
                            </Grid>
                            {/* <ButtonTheme type='submit' variant="filled" color='primary'
                                className='px-5' onClick={saveData} >
                                Save
                            </ButtonTheme> */}
                        </Grid>
                    </Grid>
                </div>
                <div style={{ marginTop: '6px' }}>
                    <Row className='gx-4'>
                        <Col xs="auto" style={{ paddingRight: '0px', paddingLeft: '0px', marginBottom: '10px' }}>
                            <div style={{ width: '170px' }} className={activeTab == 'my-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
                                onClick={() => setActiveTab('my-signups')}>
                                My Signups
                            </div>
                        </Col>

                        {(permission.includes('Emp_Auth') || permission.includes('master_user')) && <Col xs="auto" style={{ paddingRight: '0px', paddingLeft: '0px', marginBottom: '10px' }}>
                            <div style={{ width: '170px' }} className={activeTab == 'all-signups' ? 'tab-active mx-1' : 'tab-white mx-1'}
                                onClick={() => {
                                    setActiveTab('all-signups')
                                    navigation('/firehouse/all-signups')
                                }}>
                                All Signups
                            </div>
                        </Col>}
                    </Row>
                </div>
                <div style={{ marginTop: '6px', display: 'flex', justifyContent: 'center' }}>
                    <Grid item xs={12} md={'auto'} sx={{ "& .MuiBox-root": { marginTop: "0px" } }}>
                        {/* <CalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate}  minDate={new Date()} /> */}
                        <NewCalendarPicker selectedDate={selectedDate} setSelectedDate={setSelectedDate} minDate={new Date()} />
                    </Grid>
                </div>
            </Paper>
            <>
                {loading ? (
                    <Box className="w-100 d-flex justify-content-center align-items-center mt-2"
                        style={{ height: '510px' }}>
                        <CircularProgress />
                    </Box>
                ) : (<>
                    {(v3Data?.V3_Overtime_Signup_Custom_Time_Allow || v3Data?.V3_Overtime_Signup_Custom_Time_Allow == 'true') ? (
                        <>
                            <div className="mt-2">
                                {totalWeeks?.map((days, weekIndex) => (
                                    <CustomAccordion
                                        key={weekIndex}
                                        titleLeft={`Week of ${formatDate(days.week_start_date)} - ${formatDate(days.week_end_date)}`}
                                        defaultOpen={anyExpanded}
                                    >
                                        {days?.days?.map((shift, dayIndex) => (
                                            <Paper
                                                key={dayIndex}
                                                elevation={1}
                                                style={{
                                                    border: "1px solid #E5E7EB",
                                                    borderRadius: 12,
                                                    overflow: "hidden",
                                                    margin: "8px 0",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        backgroundColor: "#F9FAFB",
                                                        padding: "12px 16px",
                                                        fontWeight: 300,
                                                        borderBottom: "1px solid #E5E7EB",
                                                        color: '#6E7C87',
                                                        fontSize: 14,
                                                    }}
                                                >
                                                    {shift?.shiftDate
                                                        ? 
                                                        moment(shift.shiftDate, "YYYY-MM-DD").format("dddd, MMM DD")
                                                        : ""}
                                                </div>

                                                <div style={{ padding: "6px" }}>
                                                    {shift?.shifts.map((s, shiftIndex) => {
                                                        const isSelected = isShiftSelected(shift.shiftDate, s.ShiftCode);
                                                        const dropdownVal = getDropdownValue(shift.shiftDate, s.ShiftCode);

                                                        return (
                                                            <div key={shiftIndex} style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                gap: 12,
                                                                marginBottom: '5px',
                                                            }}>
                                                                <Chip
                                                                    label={s.name}
                                                                    style={{
                                                                        backgroundColor: s.name === "Day" ? "#FFDAAA" : "#C0DFF4",
                                                                        color: "#000",
                                                                        fontSize: 12,
                                                                        height: 28,
                                                                        minWidth: 60,
                                                                    }}
                                                                />

                                                                <div style={{ flex: 1 }}></div>

                                                                {shouldShowDropdown(shift.shiftDate, s.ShiftCode) && <div style={{ gap: 12, display: 'flex' }}>
                                                                    {(shouldShowCustomChip(pendingUpdates, shift.shiftDate, s.ShiftCode, s.name) || s.hasPrevAction) && (<Chip label="Custom Time" size="small" style={{ backgroundColor: "#E1EDE8", marginLeft: 6, marginTop: "5px", font: '10px', fontFamily: 'karla' }} />)}
                                                                    <div style={{ position: "relative", width: 200 }}>
                                                                        <select
                                                                            value={dropdownVal}
                                                                            onChange={(e) => {
                                                                                const value = e.target.value;
                                                                                handleDropdownChange(shift.shiftDate, s.ShiftCode, value);
                                                                                if (value === "full shift") {
                                                                                    saveSingleShift({
                                                                                        ShiftDate: shift.shiftDate,
                                                                                        ShiftCode: s.ShiftCode,
                                                                                        Start_Time: s.start_time,
                                                                                        End_Time: s.end_time,
                                                                                        isFullTime: true
                                                                                    });
                                                                                } else {
                                                                                    const parsed = parseTimeRange(value);
                                                                                    if (parsed) {
                                                                                        saveSingleShift({
                                                                                            ShiftDate: shift.shiftDate,
                                                                                            ShiftCode: s.ShiftCode,
                                                                                            Start_Time: parsed.start,
                                                                                            End_Time: parsed.end,
                                                                                            isFullTime: false
                                                                                        });
                                                                                    }
                                                                                }

                                                                            }}
                                                                            style={{
                                                                                width: "100%",
                                                                                padding: "8px 32px 8px 12px",
                                                                                borderRadius: 6,
                                                                                border: "1px solid #D1D5DB",
                                                                                fontSize: 14,
                                                                                backgroundColor: "#FFFFFF",
                                                                                appearance: "none",
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <option value="">Select values</option>
                                                                            <option value="full shift">Full shift</option>
                                                                            {
                                                                                Object.keys(overtimeHours).find((key) => s.name.toLowerCase().includes(key.toLowerCase()))
                                                                                &&
                                                                                overtimeHours[
                                                                                    Object.keys(overtimeHours).find((key) =>
                                                                                        s.name.toLowerCase().includes(key.toLowerCase())
                                                                                    )
                                                                                ]?.map((opt, i) => (
                                                                                    <option key={i} value={opt}>
                                                                                        {opt}
                                                                                    </option>
                                                                                ))
                                                                            }
                                                                        </select>
                                                                        <span
                                                                            style={{
                                                                                position: "absolute",
                                                                                right: 10,
                                                                                top: "50%",
                                                                                transform: "translateY(-50%)",
                                                                                pointerEvents: "none",
                                                                                fontSize: 12,
                                                                                color: "#6B7280",
                                                                            }}
                                                                        >
                                                                            <ArrowDropDownIcon />
                                                                        </span>
                                                                    </div>
                                                                </div>}

                                                                <Grid
                                                                    item
                                                                    xs={4}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        gap: 12,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            backgroundColor: "#F3F4F6",
                                                                            borderRadius: 12,
                                                                            padding: 4,
                                                                            gap: 4,
                                                                        }}
                                                                    >
                                                                        <Button
                                                                            onClick={() => {
                                                                                handleDropdownChange(shift.shiftDate, s.ShiftCode, "");
                                                                                selectShift(shift.shiftDate, s.ShiftCode, "unavailable", "", s.start_time, s.end_time);
                                                                                clearPendingUpdateForShift(shift.shiftDate, s.ShiftCode);
                                                                                setTimeout(() => {
                                                                                    deleteSingleShift({
                                                                                        ShiftDate: shift.shiftDate,
                                                                                        ShiftCode: s.ShiftCode,
                                                                                        Emp_Code: String(user?.Emp_Code || "")
                                                                                    });
                                                                                }, 50);
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: !isSelected ? "#BF1D2D" : "transparent",
                                                                                border: "none",
                                                                                color: !isSelected ? "#fff" : "#6B7280",
                                                                                textTransform: "none",
                                                                                fontSize: 12,
                                                                                fontWeight: 300,
                                                                                padding: "3px 6px",
                                                                                borderRadius: 8,
                                                                                fontFamily: 'karla',
                                                                                minWidth: 100,
                                                                                boxShadow: !isSelected ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                                                                            }}
                                                                        >
                                                                            Unavailable
                                                                        </Button>

                                                                        <Button
                                                                            // onClick={() => {
                                                                            //     const dropdownValue = getDropdownValue(shift.shiftDate, s.ShiftCode);



                                                                            //     // Check if user selected custom time from dropdown
                                                                            //     if (dropdownValue !== "full shift") {
                                                                            //         // Custom time from dropdown
                                                                            //         const parsed = parseTimeRange(dropdownValue);
                                                                            //         if (parsed) {
                                                                            //             saveSingleShift({
                                                                            //                 ShiftDate: shift.shiftDate,
                                                                            //                 ShiftCode: s.ShiftCode,
                                                                            //                 Start_Time: parsed.start,
                                                                            //                 End_Time: parsed.end,
                                                                            //                 isFullTime: false
                                                                            //             });
                                                                            //         }
                                                                            //     } else {
                                                                            //         // Full shift selected
                                                                            //         saveSingleShift({
                                                                            //             ShiftDate: shift.shiftDate,
                                                                            //             ShiftCode: s.ShiftCode,
                                                                            //             Start_Time: s.start_time,
                                                                            //             End_Time: s.end_time,
                                                                            //             isFullTime: true
                                                                            //         });
                                                                            //     }
                                                                            // }}
                                                                            onClick={() => {
                                                                                saveSingleShift({
                                                                                    ShiftDate: shift.shiftDate,
                                                                                    ShiftCode: s.ShiftCode,
                                                                                    Start_Time: s.start_time,
                                                                                    End_Time: s.end_time,
                                                                                    isFullTime: true
                                                                                });
                                                                                handleDropdownChange(shift.shiftDate, s.ShiftCode, "full shift");

                                                                            }}
                                                                            style={{
                                                                                backgroundColor: isSelected ? "#2E7D32" : "transparent",
                                                                                border: "none",
                                                                                color: isSelected ? "#FFFFFF" : "#6B7280",
                                                                                textTransform: "none",
                                                                                fontSize: 12,
                                                                                fontWeight: 300,
                                                                                padding: "3px 6px",
                                                                                borderRadius: 8,
                                                                                fontFamily: 'karla',
                                                                                minWidth: 100,
                                                                                boxShadow: isSelected ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                                                                            }}
                                                                        >
                                                                            Available
                                                                        </Button>
                                                                    </div>
                                                                </Grid>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </Paper>
                                        ))}
                                    </CustomAccordion>
                                ))}
                            </div>

                        </>
                    ) : (
                        <div className="mt-2">
                            {totalWeeks?.map((days, weekIndex) => (
                                <CustomAccordion
                                    key={weekIndex}
                                    titleLeft={`Week of ${formatDate(days.week_start_date)} - ${formatDate(days.week_end_date)}`}
                                    defaultOpen={anyExpanded}
                                >
                                    {days?.days?.map((shift, dayIndex) => {
                                        // console.log("shift=====>995",shift)
                                         return <Paper
                                            key={dayIndex}
                                            elevation={1}
                                            style={{
                                                border: "1px solid #E5E7EB",
                                                borderRadius: 12,
                                                overflow: "hidden",
                                                margin: "8px 0",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    backgroundColor: "#F9FAFB",
                                                    padding: "12px 16px",
                                                    fontWeight: 300,
                                                    borderBottom: "1px solid #E5E7EB",
                                                    color: '#6E7C87',
                                                    fontSize: 14,
                                                }}
                                            >
                                                {shift?.shiftDate
                                                    ? 
                                                   moment(shift.shiftDate, "YYYY-MM-DD").format("dddd, MMM DD")
                                                   
                                                    : ""}

                                            </div>

                                            <div style={{ padding: "6px" }}>
                                                {shift?.shifts.map((s, shiftIndex) => {
                                                    const isSelected = isShiftSelected(shift.shiftDate, s.ShiftCode);
                                                    // const isFullTime = isShiftFullTime(shift.shiftDate, s.ShiftCode);
                                                    const selectedShift = getSelectedShiftTimes(
                                                        shift.shiftDate,
                                                        s.ShiftCode
                                                    );
                                                    const hasCustom =
                                                        !!selectedShift &&
                                                        (
                                                            selectedShift.Start_Time !== s.start_time ||
                                                            selectedShift.End_Time !== s.end_time
                                                        );
                                                    // console.log("isFullTime===>691",hasCustom,isSelected);


                                                    return (
                                                        <Grid
                                                            // container
                                                            key={shiftIndex}
                                                            alignItems="center"
                                                            style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', padding: '5px' }}
                                                        >
                                                            <Grid
                                                                item
                                                                xs={2}
                                                                style={{ display: "flex", alignItems: "center", justifyContent: 'center', gap: 10 }}
                                                            >
                                                                <Chip
                                                                    label={s.name}
                                                                    style={{
                                                                        backgroundColor: s.name === "Day"
                                                                            ? "#FFDAAA"
                                                                            : "#DEEEF9",

                                                                        color: "#000000",
                                                                        borderRadius: "20px",
                                                                        minWidth: "80px",

                                                                    }}
                                                                />

                                                                <p style={{ fontSize: 14, color: "#4B5563", marginTop: '10px' }}>{`${s.start_time}-${s.end_time}`}</p>
                                                            </Grid>

                                                            <div style={{ display: 'flex', gap: '15px' }}>
                                                                <Grid
                                                                    item
                                                                    xs={6}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        gap: 10,
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    {/* {(hasCustom || s.hasPrevAction) && (<Chip label="Custom Time" size="small" style={{ backgroundColor: "#E1EDE8", marginLeft: 6, font: '10px', fontFamily: 'karla' }} />)}

                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <TimePicker
                                                                            value={
                                                                                (() => {
                                                                                    const selectedShift = getSelectedShiftTimes(shift.shiftDate, s.ShiftCode);
                                                                                    const timeToShow = selectedShift?.Start_Time || s.start_time;
                                                                                    return timeToShow ? dayjs(timeToShow, "HH:mm") : null;
                                                                                })()
                                                                            }
                                                                            onChange={(newValue) => {
                                                                                selectShift(shift.shiftDate, s.ShiftCode, 'start_time', newValue, s.start_time, s.end_time);
                                                                            }}
                                                                            // disabled={isFullTime}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: "small",
                                                                                    sx: {
                                                                                        width: 120,
                                                                                        fontSize: "13px",
                                                                                        "& .MuiInputBase-input": {
                                                                                            fontSize: "13px",
                                                                                            padding: "6px 8px",
                                                                                        }
                                                                                    },
                                                                                },
                                                                                openPickerButton: {
                                                                                    sx: {
                                                                                        "& svg": {
                                                                                            fontSize: "20px",
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider>

                                                                    <span>-</span>

                                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                        <TimePicker
                                                                            value={
                                                                                (() => {
                                                                                    const selectedShift = getSelectedShiftTimes(shift.shiftDate, s.ShiftCode);
                                                                                    const timeToShow = selectedShift?.End_Time || s.end_time;
                                                                                    return timeToShow ? dayjs(timeToShow, "HH:mm") : null;
                                                                                })()
                                                                            }
                                                                            onChange={(newValue) => {
                                                                                selectShift(shift.shiftDate, s.ShiftCode, 'end_time', newValue, s.start_time, s.end_time);
                                                                            }}
                                                                            // disabled={isFullTime || (s.prevAction === 'FULLTIME')}
                                                                            slotProps={{
                                                                                textField: {
                                                                                    size: "small",
                                                                                    sx: {
                                                                                        width: 120,
                                                                                        fontSize: "13px",
                                                                                        "& .MuiInputBase-input": {
                                                                                            fontSize: "13px",
                                                                                            padding: "6px 8px",
                                                                                        }
                                                                                    },
                                                                                },
                                                                                openPickerButton: {
                                                                                    sx: {
                                                                                        "& svg": {
                                                                                            fontSize: "20px",
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                        />
                                                                    </LocalizationProvider> */}
                                                                    {isSelected && (
                                                                        <>
                                                                        {(hasCustom || s.hasPrevAction) && (<Chip label="Custom Time" size="small" style={{ backgroundColor: "#E1EDE8", marginLeft: 6, font: '10px', fontFamily: 'karla' }} />)}
                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <TimePicker
                                                                                    value={
                                                                                        (() => {
                                                                                            const selectedShift = getSelectedShiftTimes(shift.shiftDate, s.ShiftCode);
                                                                                            const timeToShow = selectedShift?.Start_Time || s.start_time;
                                                                                            return timeToShow ? dayjs(timeToShow, "HH:mm") : null;
                                                                                        })()
                                                                                    }
                                                                                    onChange={(newValue) => {
                                                                                        const updated = selectShift(
                                                                                            shift.shiftDate,
                                                                                            s.ShiftCode,
                                                                                            'start_time',
                                                                                            newValue,
                                                                                            s.start_time,
                                                                                            s.end_time
                                                                                        );

                                                                                        // 🔥 API CALL ON CHANGE
                                                                                        const obj = updated.find(
                                                                                            x => x.ShiftDate == shift.shiftDate && x.ShiftCode == s.ShiftCode
                                                                                        );

                                                                                        if (obj?.Start_Time && obj?.End_Time) {
                                                                                            saveSingleShift({
                                                                                                ShiftDate: obj.ShiftDate,
                                                                                                ShiftCode: obj.ShiftCode,
                                                                                                Start_Time: obj.Start_Time,
                                                                                                End_Time: obj.End_Time,
                                                                                                isFullTime: false
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                    slotProps={{
                                                                                        textField: {
                                                                                            size: "small",
                                                                                            sx: {
                                                                                                width: 120,
                                                                                                fontSize: "13px",
                                                                                                "& .MuiInputBase-input": {
                                                                                                    fontSize: "13px",
                                                                                                    padding: "6px 8px",
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                        openPickerButton: {
                                                                                            sx: {
                                                                                                "& svg": {
                                                                                                    fontSize: "20px",
                                                                                                }
                                                                                            }
                                                                                        }
                                                                            }}
                                                                                />
                                                                            </LocalizationProvider>

                                                                            <span>-</span>

                                                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                                <TimePicker
                                                                                    value={
                                                                                        (() => {
                                                                                            const selectedShift = getSelectedShiftTimes(shift.shiftDate, s.ShiftCode);
                                                                                            const timeToShow = selectedShift?.End_Time || s.end_time;
                                                                                            return timeToShow ? dayjs(timeToShow, "HH:mm") : null;
                                                                                        })()
                                                                                    }
                                                                                    onChange={(newValue) => {
                                                                                        const updated = selectShift(
                                                                                            shift.shiftDate,
                                                                                            s.ShiftCode,
                                                                                            'end_time',
                                                                                            newValue,
                                                                                            s.start_time,
                                                                                            s.end_time
                                                                                        );

                                                                                        // 🔥 API CALL ON CHANGE
                                                                                        const obj = updated.find(
                                                                                            x => x.ShiftDate == shift.shiftDate && x.ShiftCode == s.ShiftCode
                                                                                        );

                                                                                        if (obj?.Start_Time && obj?.End_Time) {
                                                                                            saveSingleShift({
                                                                                                ShiftDate: obj.ShiftDate,
                                                                                                ShiftCode: obj.ShiftCode,
                                                                                                Start_Time: obj.Start_Time,
                                                                                                End_Time: obj.End_Time,
                                                                                                isFullTime: false
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                     slotProps={{
                                                                                textField: {
                                                                                    size: "small",
                                                                                    sx: {
                                                                                        width: 120,
                                                                                        fontSize: "13px",
                                                                                        "& .MuiInputBase-input": {
                                                                                            fontSize: "13px",
                                                                                            padding: "6px 8px",
                                                                                        }
                                                                                    },
                                                                                },
                                                                                openPickerButton: {
                                                                                    sx: {
                                                                                        "& svg": {
                                                                                            fontSize: "20px",
                                                                                        }
                                                                                    }
                                                                                }
                                                                            }}
                                                                                />
                                                                            </LocalizationProvider>
                                                                        </>
                                                                    )}



                                                                </Grid>

                                                                <Grid
                                                                    item
                                                                    xs={4}
                                                                    style={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        gap: 12,
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            backgroundColor: "#F3F4F6",
                                                                            borderRadius: 12,
                                                                            padding: 4,
                                                                            gap: 4,
                                                                        }}
                                                                    >
                                                                        <Button
                                                                            onClick={() => {
                                                                                selectShift(shift.shiftDate, s.ShiftCode, "unavailable", "", s.start_time, s.end_time);
                                                                                clearPendingUpdateForShift(shift.shiftDate, s.ShiftCode);
                                                                                setTimeout(() => {
                                                                                    const updated = selectedShifts.find(
                                                                                        x => x.ShiftDate == shift.shiftDate && x.ShiftCode == s.ShiftCode
                                                                                    );

                                                                                    if (updated) {
                                                                                        deleteSingleShift(updated);
                                                                                    } else {
                                                                                        deleteSingleShift({
                                                                                            ShiftDate: shift.shiftDate,
                                                                                            ShiftCode: s.ShiftCode,
                                                                                            Start_Time: s.start_time,
                                                                                            End_Time: s.end_time,
                                                                                            isFullTime: true
                                                                                        });
                                                                                    }
                                                                                }, 50);
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: hasCustom || s.hasPrevAction || (isSelected ) ? "transparent" : "#BF1D2D",
                                                                                border: "none",
                                                                                color: hasCustom || s.hasPrevAction || (isSelected) ? "#6B7280" : "#fff",
                                                                                textTransform: "none",
                                                                                fontSize: 12,
                                                                                fontWeight: 300,
                                                                                padding: "3px 6px",
                                                                                borderRadius: 8,
                                                                                fontFamily: 'karla',
                                                                                minWidth: 100,
                                                                                boxShadow: hasCustom || s.hasPrevAction || (isSelected ) ? "none" : "0 1px 3px rgba(0,0,0,0.1)",
                                                                            }}

                                                                        >
                                                                            Unavailable
                                                                        </Button>

                                                                        <Button
                                                                            // onClick={() => {
                                                                            //     selectShift(shift.shiftDate, s.ShiftCode, "fulltime", "", s.start_time, s.end_time);

                                                                            //     setTimeout(() => {
                                                                            //         const updated = selectedShifts.find(
                                                                            //             x => x.ShiftDate == shift.shiftDate && x.ShiftCode == s.ShiftCode
                                                                            //         );

                                                                            //         if (updated) {
                                                                            //             const isCustom = updated.Start_Time || updated.End_Time;

                                                                            //             saveSingleShift({
                                                                            //                 ShiftDate: updated.ShiftDate,
                                                                            //                 ShiftCode: updated.ShiftCode,
                                                                            //                 Start_Time: updated.Start_Time || s.start_time,
                                                                            //                 End_Time: updated.End_Time || s.end_time,
                                                                            //                 isFullTime: isCustom ? false : true
                                                                            //             });
                                                                            //         } else {
                                                                            //             saveSingleShift({
                                                                            //                 ShiftDate: shift.shiftDate,
                                                                            //                 ShiftCode: s.ShiftCode,
                                                                            //                 Start_Time: s.start_time,
                                                                            //                 End_Time: s.end_time,
                                                                            //                 isFullTime: true
                                                                            //             });
                                                                            //         }
                                                                            //     }, 50);
                                                                            // }}
                                                                            onClick={() => {
                                                                                selectShift(
                                                                                    shift.shiftDate,
                                                                                    s.ShiftCode,
                                                                                    "fulltime",
                                                                                    "",
                                                                                    s.start_time,
                                                                                    s.end_time
                                                                                );

                                                                                saveSingleShift({
                                                                                    ShiftDate: shift.shiftDate,
                                                                                    ShiftCode: s.ShiftCode,
                                                                                    Start_Time: s.start_time,
                                                                                    End_Time: s.end_time,
                                                                                    isFullTime: true
                                                                                });
                                                                            }}
                                                                            style={{
                                                                                backgroundColor: hasCustom || s.hasPrevAction || (isSelected ) ? "#2E7D32" : "transparent",
                                                                                border: "none",
                                                                                color: hasCustom || s.hasPrevAction || (isSelected ) ? "#FFFFFF" : "#6B7280",
                                                                                textTransform: "none",
                                                                                fontSize: 12,
                                                                                fontWeight: 300,
                                                                                padding: "3px 6px",
                                                                                borderRadius: 8,
                                                                                fontFamily: 'karla',
                                                                                minWidth: 100,
                                                                                boxShadow: hasCustom || s.hasPrevAction || (isSelected) ? "0 1px 3px rgba(0,0,0,0.1)" : "none",
                                                                            }}
                                                                        >
                                                                            Available
                                                                        </Button>
                                                                    </div>
                                                                </Grid>
                                                            </div>

                                                        </Grid>
                                                    );
                                                })}
                                            </div>
                                        </Paper>
                                    }
                                        
                                        
                                    )}
                                </CustomAccordion>
                            ))}
                        </div>
                    )}

                </>)
                }
            </>

        </>
    )
}

export default VolunteerSignupNew;